import isNumber from './isNumber';
import { SINGLE_VALUE_PROGRESS_COLOR } from '../constants';
import { ProgressLabelDatum, ProgressNodeDatum } from '../Progress';

const normalizeData = (data: number | Array<ProgressNodeDatum> | Array<ProgressLabelDatum>) =>
  isNumber(data) ? [{ value: data, color: SINGLE_VALUE_PROGRESS_COLOR }] : data;

export default normalizeData;
